import Flux from 'lib/flux';
import IntegrationConstants from 'constants/integration';
import 'stores/plugins/integration';
import IntegrationService from 'services/integration';
import $ from 'jquery';

const INTERCOM_SCROLL_POLLING = 100;
let __intercomScrollInterval;

function decorateUrl(url) {
  // if there is google tracking grab the linker param to append it
  const gobj = window[window.GoogleAnalyticsObject]; // this is just the 'ga' function
  const linkerParam = gobj ? gobj.getAll()[0].get('linkerParam') : undefined; // returns '_ga=1.1234.123456' linker parameter
  if (!linkerParam) {
    return url;
  }

  const hasQuery = url.split('?').length > 1;
  return hasQuery ? url.concat('&', linkerParam) : url.concat('?', linkerParam);
}

const IntegrationActionCreator = Flux.createActionCreator({
  redirect_to(url, { external } = { external: false }) {
    if (window.self === window.parent) {
      const decoratedUrl = decorateUrl(url);
      window.location = decoratedUrl;
    } else {
      window.jQuery.postMessage(
        {
          url: window.location.href,
          redirect: 'true',
          // delegate adding the ga linker param to the parent so we preserve the correct ID when redirecting
          redirect_url: url,
          external,
        },
        '*',
        this._target()
      );
    }
  },

  startScrollingIntercom() {
    __intercomScrollInterval = setInterval(() => {
      IntegrationService.queryParentViewport().then((viewportData) => {
        const height = $(document).height();
        const $widget = $('div.intercom-lightweight-app-launcher').length
          ? $('div.intercom-lightweight-app-launcher')
          : $('div.intercom-launcher');

        const $widgetBox = $('div.intercom-messenger-frame');

        const offset =
          parseInt(viewportData.centersDelta) -
          parseInt(height / 2) +
          parseInt(viewportData.height / 2);

        $widget.css({
          transition: 'transform 0.25s',
          transform: `translateY(${Math.min(offset, 0)}px)`,
        });

        $widgetBox.css({
          transition: 'transform 0.25s',
          transform: `translateY(${Math.min(offset, 0)}px)`,
        });
      });
    }, INTERCOM_SCROLL_POLLING);
  },

  stopScrollingIntercom() {
    clearInterval(__intercomScrollInterval);
  },

  queryParentViewport() {
    IntegrationService.queryParentViewport().then((viewportData) => {
      this.dispatchAction(
        IntegrationConstants.UPDATE_PARENT_VIEWPORT,
        viewportData
      );
    });
  },

  queryOriginUrl() {
    IntegrationService.queryOriginUrl().then((data) => {
      this.dispatchAction(
        IntegrationConstants.UPDATE_ORIGIN_URL,
        data.originUrl
      );
    });
  },

  scrollToSelector(selector) {
    const el = $(selector);
    if (el.length) {
      IntegrationService.scrollInView(el.offset().top);
    } else {
      console.warn(
        "IntegrationService.scrollToSelector: selector didn't match",
        selector
      );
    }
  },

  scrollRelative(scroll) {
    IntegrationService.scrollRelative(scroll);
  },

  _target() {
    if (window.parent.postMessage) {
      return window.parent;
    }
    if (window.parent.document.postMessage) {
      return window.parent.document;
    }
    return undefined;
  },
});

// For the old scripts that need to communicate
export default IntegrationActionCreator;
